$(function() {
  $('.search-Dropdown_Button').on('click', function(e) {
    var $this = $(this);
    var $controls = $('#' + $this.attr('aria-controls'));
    if($this.attr('aria-expanded') === 'false') {
      $this.attr('aria-expanded', 'true');
      $controls.attr('aria-hidden', 'false').slideDown();
    } else {
      $this.attr('aria-expanded', 'false');
      $controls.attr('aria-hidden', 'true').slideUp();;
    }
    e.stopPropagation();
  });

}());
